<template>
  <f7-page class="rowBackgroundHomepage">
    <div class="layoutTop"></div>
    <b-container fluid>
      <b-row>
        <b-col :md="colWidth" :offset-md="(12 - colWidth)/2" class="p-0">
          <div v-if="!isSmartphoneOS">
            <back-button :returnUrl="returnUrl"></back-button>
          </div>
          <div class="panel21 panel-default">
            <div class="panel-heading" v-if="!isSmartphoneOS">
              <div class="showLargeScreenOnly formTitleBlock">
                <h4 class="content-block labelAccordionForm"
                  :style="{color}">
                  <f7-icon v-if="icon" :icon="icon" class="formIcon"></f7-icon>
                  <f7-icon v-else-if="iconF7" :f7="iconF7"></f7-icon>
                  <f7-icon v-else-if="iconFA" :fa="iconFA"></f7-icon>
                  <slot name="icon"></slot>
                  <span>{{ title }}</span>
                </h4>
              </div>
              <div class="showSmallScreenOnly formTitleBlock">
                <h6 class="content-block labelAccordionForm creationFormTitle"
                  :style="{color}">
                  <f7-icon v-if="icon" :icon="icon" class="formIcon"></f7-icon>
                  <f7-icon v-if="iconF7" :f7="iconF7"></f7-icon>
                  <f7-icon v-if="iconFA" :fa="iconFA"></f7-icon>
                  <slot name="icon"></slot>
                  <span>{{ title }}</span>
                </h6>
              </div>
              <div v-if="mandatoryIndication" class="content-block italicMandatoryIndication">
                {{ $t('common.asterisk_obligation_label')}}
              </div>
            </div>
            <slot name="pageContent"></slot>
          </div>
          <slot name="underPanel"></slot>
        </b-col>
      </b-row>
      <slot name="footerButtons"></slot>
      <!-- <div class="toolbarPageBottomBlank"></div> -->
    </b-container>
  </f7-page>
</template>

<script>
import backButton from '@/components/common/backButton.vue'

export default {
  name: 'PageOutline',
  components: {
    'back-button': backButton
  },
  props: {
    color: {
      default: 'var(--actionButtonColor)'
    },
    colWidth: {
      default: '10'
    },
    icon: {
      default: ''
    },
    iconF7: {
      default: ''
    },
    iconFA: {
      default: ''
    },
    mandatoryIndication: {
      type: Boolean,
      default: false
    },
    returnUrl: {
      default: 'none'
    },
    title: {
      default: 'Title'
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  created () {
    if (this.isSmartphoneOS) {
      this.$bus.$emit('change-mobile-header', {
        backLink: true,
        navbarInnerStyle: 'justify-content:start;',
        navTitle: this.title,
        returnUrl: this.returnUrl
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// PageOutline.vue?630f182e